import { Component } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-language-toggle',
  templateUrl: './language-toggle.component.html',
  styleUrls: ['./language-toggle.component.css'],
})
export class LanguageToggleComponent {
  currentLang = this.languageService.currentLanguage || 'ar';

  constructor(private languageService: LanguageService) {}

  toggle(): void {
    const next = this.currentLang === 'ar' ? 'en' : 'ar';
    this.languageService.switchLang(next);
    this.currentLang = this.languageService.currentLanguage;
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }
}
